export default function Products() {
  const products = [
    {
      title: 'Pompe à Chaleur Air/Eau',
      description: 'Solution complète pour le chauffage et l\'eau chaude sanitaire de votre habitation avec un rendement exceptionnel.',
      image: 'https://public.readdy.ai/ai/img_res/3a5a4384e03fa1f55253a3a670d404d1.jpg',
      features: ['COP jusqu\'à 4.5', 'Silencieux', 'Connecté', 'Garantie 5 ans']
    },
    {
      title: 'Pompe à Chaleur Air/Air',
      description: 'Climatisation réversible pour chauffer en hiver et rafraîchir en été avec une efficacité énergétique optimale.',
      image: 'https://readdy.ai/api/search-image?query=contemporary%20air%20to%20air%20heat%20pump%20split%20system%20with%20indoor%20and%20outdoor%20units%20showing%20modern%20climate%20control%20technology%20reversible%20heating%20cooling%20system%20clean%20minimalist%20design%20simple%20background%20emphasizing%20energy%20efficient%20hvac%20solution&width=500&height=400&seq=product-002&orientation=landscape',
      features: ['Réversible', 'Multi-split', 'Économique', 'Installation rapide']
    },
    {
      title: 'Ballon Thermodynamique',
      description: 'Production d\'eau chaude écologique et économique utilisant les calories de l\'air ambiant pour chauffer l\'eau.',
      image: 'https://readdy.ai/api/search-image?query=modern%20thermodynamic%20water%20heater%20tank%20with%20integrated%20heat%20pump%20technology%20showing%20contemporary%20hot%20water%20system%20design%20energy%20efficient%20domestic%20water%20heating%20solution%20clean%20professional%20product%20view%20simple%20neutral%20background&width=500&height=400&seq=product-003&orientation=landscape',
      features: ['Économies 70%', 'Capacité 200-300L', 'Écologique', 'Rapide']
    },
    {
      title: 'Isolation Thermique',
      description: 'Matériaux isolants haute performance pour murs, combles et sols garantissant confort et économies d\'énergie.',
      image: 'https://readdy.ai/api/search-image?query=professional%20thermal%20insulation%20installation%20showing%20high%20quality%20insulation%20materials%20being%20applied%20to%20residential%20walls%20and%20attic%20spaces%20energy%20efficient%20home%20improvement%20work%20clean%20organized%20construction%20site%20simple%20background&width=500&height=400&seq=product-004&orientation=landscape',
      features: ['Haute résistance', 'Durable', 'Certifié', 'Pose rapide']
    }
  ];

  return (
    <section id="products" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nos Produits et Solutions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Équipements de haute qualité pour votre confort et vos économies d'énergie
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative" style={{ width: '100%', height: '300px' }}>
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
                  Disponible
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{product.title}</h3>
                <p className="text-sm text-gray-600 mb-6 leading-relaxed">{product.description}</p>
                <div className="grid grid-cols-2 gap-3">
                  {product.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <div className="w-6 h-6 flex items-center justify-center bg-teal-100 rounded-full">
                        <i className="ri-check-line text-teal-600 text-sm"></i>
                      </div>
                      <span className="text-sm text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">Besoin de conseils personnalisés ?</h3>
          <p className="text-lg mb-8 opacity-90">
            Nos experts sont à votre disposition pour vous guider dans le choix de la solution la plus adaptée à vos besoins
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-white text-teal-600 px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            Contactez-nous
          </button>
        </div>
      </div>
    </section>
  );
}
